export const BLOG_POSTS = `
query BlogPosts($pagination: Int, $perPage: Int) {
    blogPosts (pagination: { page: $pagination, pageSize: $perPage } sort: "Datum:desc") {
        documentId
        title
        slug
        publishedAt
        Datum
        previewImage {
            url
            alternativeText
        }
    }
}
`;
